import styled from "styled-components"

export const Wrapper = styled.div`
  &.slick-disabled{
    opacity: 0.5;
    cursor: not-allowed;
  }
`
